import React from 'react';
import PropTypes from 'prop-types';

const FinancialTable = ({ children, className, ...other }) => {
  return (
    <div className={className} {...other}>
      {children}
    </div>
  );
};

FinancialTable.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FinancialTable.defaultProps = {
  className: '',
};

export default FinancialTable;
